export class DepartmentInput {
    public name: string = '';
    public securityLevel: string = '';
}
